import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AiFillThunderbolt } from 'react-icons/ai';

import { ROUTES } from 'utils/constants';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { KEYS } from 'components/evieOnboarding/utils/constants';
import { useEvieChatContext } from '../EvieChatProvider';

import './messages-left.scss';

const MessagesLeft = () => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const { messagesLeft, isAwaitingResponse } = useEvieChatContext();
  const [, setFlow] = useLocalStorage(KEYS.FLOW);

  const handleGoToPayment = async () => {
    // await (on a non-promise) defers push() to a microtask, forcing the flow
    // state update to flush in its own commit before navigation can unmount this
    // component — otherwise React may batch both updates into one commit and
    // drop the pending write.
    await setFlow('assistant');
    push(`${ROUTES.EVIE_ONBOARDING}?view=plans&entry=messages_left`);
  };
  const singularOrPlural = messagesLeft === 1 ? 'singular' : 'label';

  return (
    <p className="messages-left">
      <AiFillThunderbolt color="#9b2c51" />
      {t(`evieApp.assistant.messagesLeft.${singularOrPlural}`, { count: messagesLeft })}
      &nbsp;
      <button type="button" disabled={isAwaitingResponse} onClick={handleGoToPayment}>
        {t('evieApp.assistant.messagesLeft.upgrade')}
      </button>
    </p>
  );
};

export default MessagesLeft;
